import { z } from "zod";

export const AuthErrorCodeSchema = z.enum([
  "UNAUTHENTICATED",
  "TOKEN_EXPIRED",
  "NO_ACCOUNT_MEMBERSHIP",
  "INACTIVE_ACCOUNT_USER",
  "FORBIDDEN_BUSINESS",
  "FORBIDDEN_ACTION",
  "IMPERSONATION_CONFIRMATION_REQUIRED",
  // ADV-295 — unified JWT + API-key middleware
  "FORBIDDEN_API_KEY_AUTH",
  "INSUFFICIENT_SCOPE",
]);
export type AuthErrorCode = z.infer<typeof AuthErrorCodeSchema>;

export const AccountRoleSchema = z.enum([
  "super_admin",
  "admin",
  "billing", // reserved for future use — no routes or UI surfaces enforce billing-only access yet
  "viewer",
]);
export type AccountRole = z.infer<typeof AccountRoleSchema>;

// Business-level roles on account_user_businesses.role (ADV-227).
export const BusinessRoleSchema = z.enum([
  "admin",
  "supervisor",
  "member",
  "worker",
  "viewer",
]);
export type BusinessRole = z.infer<typeof BusinessRoleSchema>;

// ADV-879: unified role model. systemRole replaces accountRole; endUserRole
// replaces businessRole (only meaningful when systemRole === "user"). See
// docs/adr/0027-unified-role-model-casl-adoption.md and the canonical
// definitions in @adva/auth/abilities.
export const SystemRoleSchema = z.enum([
  "super_admin",
  "admin",
  "billing",
  "user",
]);
export type SystemRole = z.infer<typeof SystemRoleSchema>;

export const EndUserRoleSchema = z.enum([
  "salesperson",
  "crew_chief",
  "manager",
]);
export type EndUserRole = z.infer<typeof EndUserRoleSchema>;
